import {Observable} from 'rxjs';

export abstract class BaseCustomTextService {
  public abstract getCustomText(id: string): Observable<string>;
}
